import { BaseDTO } from "../global/base.dto";
import { UserListDTO } from "../user/user-list.dto";
import { ResourceGroupListDTO } from '../resource-group/resource-group-list.dto';

export class TeamDTO extends BaseDTO {

    name: string;
    
    description: string;
    
    phone: string;
    
    email: string;

    type: number;

    users: Array<UserListDTO>;

    resourceGroups: Array<ResourceGroupListDTO>;

}
